"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MedicalClipboard = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const MedicalClipboard = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-3.65 -1.65)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M13.1,4H17V18.35H4V4H7.9",
        transform: "translate(0 -1.35)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M17.15,10H19.1V20.45H10V10h1.95",
        transform: "translate(-4.05 -5.4)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M16,2V5.9h1.3a1.3,1.3,0,1,1,2.6,0h1.3V2Z",
        transform: "translate(-8.1)",
        strokeLinecap: "square"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        transform: "translate(-0.619 -0.619)",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          y2: "3.619",
          transform: "translate(11.309 8.5)",
          strokeLinecap: "square"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x2: "3.619",
          transform: "translate(9.5 10.054)",
          strokeLinecap: "square"
        })]
      })]
    })
  });
};
exports.MedicalClipboard = MedicalClipboard;